import React, { useEffect, useRef, useState } from 'react'
import { ClientsImg, ClientsImg2 } from './clinetsImage';

const clientDescriptions = {
  "cloudshim-logo": "Intelligent cloud cost optimization solution",
  "abp-logo": "Digital solutions for a leading Indian media organization",
  "abb-logo": "Electrification and automation solutions",
  "cryoport-logo": "Temperature-controlled logistics solutions",
  "cigna-logo": "Advanced health solutions platform",
  "medhost-logo": "Emergency department information system",
  "the-fragrances-shop-logo": "Mobile application for fragrances and beauty products",
  "pebble-logo": "Custom application for Pebble smartwatches",
  "kia-logo": "A comprehensive mobile app for KIA car owners",
  "paypal-logo": "Development of customizable payment forms",
  "acima-logo": "Lease-to-own financial service platform",
  "tonik-bank-logo": "Digital-only banking platform in the Philippines",
  "property-finder-logo": "Platform connecting clients with the real estate market",
  "inkind-logo": "Dynamic dining rewards platform",
  "ethmeme-logo": "Platform for creating and trading cryptocurrency tokens",
  "verizon-logo": "Human Resource Management automation solutions",
  "wendy-logo": "Restaurant and dining mobile application",
  "sonic-healthcare-logo": "Solutions for a global healthcare provider",
  "cardinalhire": "Recruitment platform connecting tech talent",
  "scoutr-logo": "Talent management platform",
  "styla-logo": "Headless frontend experience platform",
  "digikagaz-logo": "Document automation platform for legal professionals",
  "bhai-bandhu-logo": "B2B marketplace for Indian ethnic wear",
  "puravankara-logo": "Leading real estate company in India",
  "canopie-logo": "Mobile app for maternal mental health care",
  "shree-laxmi-steels-logo": "Comprehensive CRM system",
  "wazir-logo": "Cryptocurrency trading application",
};

function HoverCard({ image, setIsPaused }) {
  const [hovered, setHovered] = useState(false);
  const description = clientDescriptions[image.alt] || "Trusted technology partner";

  return (
    <div
      className="flex justify-center justify-items-center"
      onMouseEnter={() => { setIsPaused(true); setHovered(true); }}
      onMouseLeave={() => { setIsPaused(false); setHovered(false); }}
    >
      <div
        style={{
          width: '200px',
          height: '95px',
          borderRadius: '10px',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transition: 'box-shadow 0.3s ease, transform 0.3s ease',
          boxShadow: hovered
            ? '0 8px 24px rgba(24, 135, 201, 0.25), 0 2px 8px rgba(0,0,0,0.08)'
            : '0 1px 4px rgba(0,0,0,0.04)',
          transform: hovered ? 'translateY(-3px)' : 'translateY(0)',
          background: '#fff',
          cursor: 'default',
        }}
      >
        {/* Logo */}
        <img
          width="800"
          height="600"
          sizes="(max-width: 640px) 100vw, (max-width: 1280px) 50vw, 33vw"
          loading="lazy"
          src={image.src}
          alt={image.alt}
          style={{
            height: 'auto',
            width: 'auto',
            maxWidth: '100%',
            maxHeight: '100%',
            transition: 'opacity 0.3s ease, transform 0.3s ease',
            opacity: hovered ? 0.15 : 1,
            transform: hovered ? 'scale(0.92)' : 'scale(1)',
            filter: image.fill ? 'invert(1)' : 'none',
          }}
        />

        {/* Overlay description */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 10px',
            opacity: hovered ? 1 : 0,
            transform: hovered ? 'translateY(0)' : 'translateY(8px)',
            transition: 'opacity 0.3s ease, transform 0.3s ease',
          }}
        >
          <p
            style={{
              color: '#1887C9',
              fontSize: '0.70rem',
              fontWeight: 600,
              textAlign: 'center',
              lineHeight: '1.4',
              margin: 0,
              letterSpacing: '0.01em',
            }}
          >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}

function ClientCard({ bgColor, heading, description }) {
  const [isPaused, setIsPaused] = useState(false);
  const webScrollRef = useRef(null);
  const mobScrollRef = useRef(null);

  const ClientsImgLoop = [...ClientsImg, ...ClientsImg];
  const ClientsImg2Loop = [...ClientsImg2, ...ClientsImg2];

  const handleScroll = () => {
    if (webScrollRef.current && webScrollRef.current.scrollLeft <= webScrollRef.current.scrollWidth / 2) {
      webScrollRef.current.scrollLeft = webScrollRef.current.scrollWidth;
    }
  };

  const handleMobScroll = () => {
    if (mobScrollRef.current.scrollLeft >= mobScrollRef.current.scrollWidth / 2) {
      mobScrollRef.current.scrollLeft = 0;
    }
  };

  useEffect(() => {
    const scrollContainer = webScrollRef.current;
    if (scrollContainer) scrollContainer.addEventListener('scroll', handleScroll);
    return () => { if (scrollContainer) scrollContainer.removeEventListener('scroll', handleScroll); };
  }, []);

  useEffect(() => {
    const mobContainer = mobScrollRef.current;
    if (mobContainer) mobContainer.addEventListener('scroll', handleMobScroll);
    return () => { if (mobContainer) mobContainer.removeEventListener('scroll', handleMobScroll); };
  }, []);

  useEffect(() => {
    let webScrollInterval;
    let mobScrollInterval;

    if (!isPaused) {
      if (webScrollRef.current && webScrollRef.current.scrollWidth > webScrollRef.current.clientWidth) {
        webScrollInterval = setInterval(() => {
          if (webScrollRef.current) {
            if (webScrollRef.current.scrollLeft <= 0) {
              webScrollRef.current.scrollLeft = webScrollRef.current.scrollWidth;
            } else {
              webScrollRef.current.scrollLeft -= 2;
            }
          }
        }, 50);
      }

      if (mobScrollRef.current && mobScrollRef.current.scrollWidth > mobScrollRef.current.clientWidth) {
        mobScrollInterval = setInterval(() => {
          if (mobScrollRef.current) {
            if (mobScrollRef.current.scrollLeft >= mobScrollRef.current.scrollWidth - mobScrollRef.current.clientWidth) {
              mobScrollRef.current.scrollLeft = 0;
            } else {
              mobScrollRef.current.scrollLeft += 2;
            }
          }
        }, 50);
      }
    }

    return () => {
      clearInterval(webScrollInterval);
      clearInterval(mobScrollInterval);
    };
  }, [isPaused]);

  return (
    <div className={`w-auto h-auto py-[4rem] ${bgColor}`}>
      <div className="font-inter overflow-hidden mx-[7%] md:mx-[7%] xl:mx-[50px] ipad-pro:mx-[50px] justify-center pt-16 shadow-custom-lg rounded-[20px] bg-white">
        <div className="content w-full text-center text-black">
          <div className="w-full text-center px-[3%] xl:px-[30px] ipad-pro:px-[30px]" data-aos="fade-left">
            <h2
              className="font-bold text-[1.5625rem] xl:text-[2.1875rem] ipad-pro:text-[1.875rem] md:text-[2.1875rem] leading-[2.45rem] text-[#061C3D]"
              dangerouslySetInnerHTML={{ __html: heading }}
            />
            <p className="font-normal text-[0.9375rem] xl:text-[1.15rem] ipad-pro:text-[1.125rem] md:text-[1.15rem] leading-[1.5875rem] pt-[30px] text-gray-700">
              {description}
            </p>
          </div>
        </div>

        <div className="content xl:px-[30px] ipad-pro:px-[30px] px-[3%] text-center flex flex-col">
          <div
            ref={webScrollRef}
            className="w-full flex gap-[1.5rem] overflow-x-auto scrollbar-hidden h-[100%] pt-[30px]"
            onKeyDown={(e) => {
              if (e.key === 'ArrowRight') webScrollRef.current.scrollLeft += 50;
              if (e.key === 'ArrowLeft') webScrollRef.current.scrollLeft -= 50;
            }}
            tabIndex={0}
          >
            {ClientsImgLoop.map((image, idx) => (
              <HoverCard key={`row1-${image.id}-${idx}`} image={image} setIsPaused={setIsPaused} />
            ))}
          </div>

          <div
            ref={mobScrollRef}
            className="w-full flex gap-[1.5rem] overflow-x-auto scrollbar-hidden h-[100%] pb-[30px]"
            onKeyDown={(e) => {
              if (e.key === 'ArrowRight') mobScrollRef.current.scrollLeft += 50;
              if (e.key === 'ArrowLeft') mobScrollRef.current.scrollLeft -= 50;
            }}
            tabIndex={0}
          >
            {ClientsImg2Loop.map((image, idx) => (
              <HoverCard key={`row2-${image.id}-${idx}`} image={image} setIsPaused={setIsPaused} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientCard;